module.exports = __webpack_public_path__ + "img/answer4.5ae3daaa.jpg";